"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushEvent = void 0;
var isBrowser = typeof window !== "undefined";
var pushEvent = function pushEvent(scrollDepth) {
  if (isBrowser) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "scroll-event",
      scrollDepth: "".concat(scrollDepth)
    });
  }
};
exports.pushEvent = pushEvent;